module.exports = __webpack_public_path__ + "static/media/pf.b6f47989.svg";